import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { getStoredTokenPayload, isTokenExpired } from '../../helpers/token/token.helper';
import { TSP } from '../../models';

/**
 * Builds a guard that only admits the given roles. The list is a parameter so widening access later is a
 * one-line change at the call site rather than an edit inside the guard.
 *
 * This is UX, not security: the token lives in `localStorage` and the check is trivially bypassed. The real
 * boundary stays in the gateway — this only keeps users out of an interface that would not work for them.
 */
export const createRoleGuard =
  (allowedRoles: TSP.Internal.Recruiter.User.Role[]): CanActivateFn =>
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    const router = inject(Router);

    const payload = getStoredTokenPayload();

    if (!payload || isTokenExpired(payload) || !allowedRoles.includes(payload.role)) {
      router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

      return false;
    }

    return true;
  };
